angular.module('mercury.modules.settings.billing')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Settings.BillingOverview', {
    url: '/billing/:id',
    controller: 'SettingsBillingOverviewCtrl',
    templateUrl: 'modules/settings/billing/overview.tpl.html'
  });
  $stateProvider.state('Settings.BillingSubscribe', {
    url: '/billing/subscribe/:id',
    controller: 'SettingsBillingSubscribeCtrl',
    templateUrl: 'modules/settings/billing/subscribe.tpl.html'
  });
  $stateProvider.state('Settings.BillingPayment', {
    url: '/billing/payment/:id/:type',
    controller: 'SettingsBillingPaymentCtrl',
    templateUrl: 'modules/settings/billing/payment.tpl.html'
  });
}]);
